import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../../store/app/selectors';
import { EXPLORE_WEB_CurrentUserForAppHeader as Data } from './__generated__/EXPLORE_WEB_CurrentUserForAppHeader';

const CURRENT_USER_QUERY = gql`
  query EXPLORE_WEB_CurrentUserForAppHeader {
    currentUser {
      id
      email
      name
      purchases {
        productID
      }
    }
  }
`;

export const CurrentUser = () => {
  const authed = useSelector(selectIsAuthenticated);

  const [fetch, { data }] = useLazyQuery<Data, null>(CURRENT_USER_QUERY, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const currentUser = data?.currentUser;
  const username = currentUser?.name;
  const email = currentUser?.email;

  let welcomeMessage = 'Welcome, anonymous user';

  if (username && email) {
    welcomeMessage = `Welcome, ${username} (${email})`;
  }

  // Print only if welcome message changes
  useEffect(() => {
    console.info(welcomeMessage);
  }, [welcomeMessage]);

  // Fetch if auth state changes
  useEffect(fetch, [authed, fetch]);

  return null;
};
